import { render, staticRenderFns } from "./InscripcionGestion.vue?vue&type=template&id=0ee414da&"
import script from "./InscripcionGestion.vue?vue&type=script&lang=js&"
export * from "./InscripcionGestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports